export const ADMIN_ROLE = 'Admin'

export const Permissions = {
  AdminAll: 'admin:*',

  AdminUsersRead: 'admin.users.read',
  AdminUsersCreate: 'admin.users.create',
  AdminUsersUpdate: 'admin.users.update',
  AdminUsersDelete: 'admin.users.delete',
  AdminUsersManageRoles: 'admin.users.manage_roles',

  AdminSystemRead: 'admin.system.read',
  AdminSystemUpdate: 'admin.system.update',

  AdminLogsRead: 'admin.logs.read',

  AdminReportsRead: 'admin.reports.read',

  AdminCompaniesCrud: 'admin.companies.*',
  AdminPartnersCrud: 'admin.partners.*',
  AdminCategoriesCrud: 'admin.categories.*',
  AdminCoursesCrud: 'admin.courses.*',
  AdminClassesCrud: 'admin.classes.*',
  AdminEnrollmentsCrud: 'admin.enrollments.*',
  AdminCommunicationsCrud: 'admin.communications.*',
  AdminCertificatesCrud: 'admin.certificates.*',
  AdminLibraryCrud: 'admin.library.*',
  AdminAssessmentsCrud: 'admin.assessments.*',
}

export const AdminFeaturePermissions = [
  {
    feature: 'CRUD de usuários',
    permissions: [
      Permissions.AdminUsersRead,
      Permissions.AdminUsersCreate,
      Permissions.AdminUsersUpdate,
      Permissions.AdminUsersDelete,
      Permissions.AdminUsersManageRoles,
    ],
  },
  {
    feature: 'Configurações do sistema',
    permissions: [Permissions.AdminSystemRead, Permissions.AdminSystemUpdate],
  },
  {
    feature: 'Logs administrativos',
    permissions: [Permissions.AdminLogsRead],
  },
  {
    feature: 'Relatórios',
    permissions: [Permissions.AdminReportsRead],
  },
  {
    feature: 'Gestão de empresas',
    permissions: [Permissions.AdminCompaniesCrud],
  },
  {
    feature: 'Gestão de parceiros SAS',
    permissions: [Permissions.AdminPartnersCrud],
  },
  {
    feature: 'Categorias e biblioteca',
    permissions: [Permissions.AdminCategoriesCrud, Permissions.AdminLibraryCrud],
  },
  {
    feature: 'Cursos, turmas e matrículas',
    permissions: [
      Permissions.AdminCoursesCrud,
      Permissions.AdminClassesCrud,
      Permissions.AdminEnrollmentsCrud,
    ],
  },
  {
    feature: 'Comunicações',
    permissions: [Permissions.AdminCommunicationsCrud],
  },
  {
    feature: 'Certificados',
    permissions: [Permissions.AdminCertificatesCrud],
  },
  {
    feature: 'Avaliações',
    permissions: [Permissions.AdminAssessmentsCrud],
  },
]

export const RolePermissionMap = {
  [ADMIN_ROLE]: [Permissions.AdminAll],
}

export function expandWildcard(permission) {
  return String(permission || '')
}

export function permissionMatches(granted, needed) {
  const g = String(granted || '')
  const n = String(needed || '')
  if (!g || !n) return false
  if (g === Permissions.AdminAll && n.startsWith('admin.')) return true
  if (g.endsWith('.*')) {
    const prefix = g.slice(0, -2)
    return n === prefix || n.startsWith(prefix + '.')
  }
  return g === n
}

